import { ValidatorInterface } from '../../interfaces/components/validator/validator.interface';
import { Injectable } from '../dependency-injection/decorators';

@Injectable()
export class Validator implements ValidatorInterface {
  public validate (object: object): Promise<boolean> | boolean {
    return true;
  }
}
